import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { WorkOrderAssignmentSubmission } from "../../shared/interfaces/WorkOrder";

export function useReassignMultipleWorkOrders() {
  const apiContext = useContext(ApiContext);
  return useMutation(["reassignWorkOrders"], async (workOrderReassignments: WorkOrderAssignmentSubmission[]) =>
    apiContext.assignmentApis.reassignMultipleWorkOrders(workOrderReassignments),
  );
}
